import { getActiveBrandConfig } from '../theme/brands';

export const useBrandTheme = () => {
  const brand = getActiveBrandConfig();

  return {
    brandKey: brand.key,
    brandName: brand.name,
    buId: brand.buId,
    appId: brand.appId,
    palette: brand.palette,
    tokens: brand.tokens,
    cssVariables: brand.cssVariables,
  };
};

export const getBrandApiHeaders = () => {
  const brand = getActiveBrandConfig();

  return {
    'X-BU-Id': brand.buId,
    'X-App-Id': brand.appId,
  };
};
